/**
 * extraLargeHero
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module styles
import './_extra-large-hero.scss';

// Module template
import './_extra-large-hero.twig';

export const name = 'extraLargeHero';

export const defaults = {
  dummyClass: 'js-extraLargeHero-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { extraLargeHero = {} }) {
  // Find our component within the DOM
  const $extraLargeHero = $('.extra-large-hero', $context);
  // Bail if component does not exist
  if (!$extraLargeHero.length) {
    return;
  }
  // Fade video out to show mma after timout
  setTimeout(() => {
    $extraLargeHero.addClass('hide-video');
  }, 2000);

  setTimeout(() => {
    $extraLargeHero.addClass('remove-loading');
  }, 3000);

  $(window).on('load', () => {
    $('.extra-large-hero .loading-icon').fadeOut('slow');
  });

  // Homepage mouse click scroll
  if ($('.extra-large-hero__bottom').length) {
    const scrollTarget = $('.extra-large-hero__bottom').offset().top - 50;
    $('.scroll-icon').click(() => {
      $('html, body').animate(
        {
          scrollTop: scrollTarget,
        },
        1000
      );
      return false;
    });
  }
  // Merge defaults with incoming settings
  const settings = Object.assign(defaults, extraLargeHero);
  // An example of what could be done with this component
  $extraLargeHero.addClass(settings.dummyClass);
}

export default enable;
